/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Update revision
 * @export
 * @interface PatchedUpdateRevision
 */
export interface PatchedUpdateRevision {
  /**
   *
   */
  commitMessage?: string | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
}

/**
 * Check if a given object implements the PatchedUpdateRevision interface.
 */
export function instanceOfPatchedUpdateRevision(value: object): value is PatchedUpdateRevision {
  return true;
}

export function PatchedUpdateRevisionFromJSON(json: any): PatchedUpdateRevision {
  return PatchedUpdateRevisionFromJSONTyped(json, false);
}

export function PatchedUpdateRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedUpdateRevision {
  if (json == null) {
    return json;
  }
  return {
    commitMessage:
      json["commit_message"] === undefined
        ? undefined
        : json["commit_message"] === null
        ? null
        : json["commit_message"],
    tags: json["tags"] == null ? undefined : json["tags"],
  };
}

export function PatchedUpdateRevisionToJSON(json: any): PatchedUpdateRevision {
  return PatchedUpdateRevisionToJSONTyped(json, false);
}

export function PatchedUpdateRevisionToJSONTyped(
  value?: PatchedUpdateRevision | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    commit_message: value["commitMessage"],
    tags: value["tags"],
  };
}
